<div class="loader" [style.--dot-size]="dotSize" [style.--loader-size]="loaderSize" [style.--dot-color]="dotColor">
</div>
